export default "__VITE_ASSET__cd1e211b__"